import { RouteItem } from '@eastcoal/router/types/route'

import {
  TRADE_SESSION_PUBLISH_ENTRY_PAGE_PATH,
  TRADE_SESSION_PUBLISH_RESULT_PAGE_PATH
} from './constants/path'
import { TRADE_SESSION_PUBLISH_ENTRY_PAGE_UUID } from './constants/uuid'

export const tradeSessionPublishRoute: RouteItem = {
  title: '发布竞价',
  hideChildrenInMenu: true,
  uuid: TRADE_SESSION_PUBLISH_ENTRY_PAGE_UUID,
  children: [
    {
      title: '发布入口',
      path: TRADE_SESSION_PUBLISH_ENTRY_PAGE_PATH,
      Component: () => import('./Entry')
    },
    {
      title: '发布结果',
      path: TRADE_SESSION_PUBLISH_RESULT_PAGE_PATH,
      hideInMenu: true,
      Component: () => import('./Result')
    }
  ]
}
